<div [ngClass]="{'':params?.data?.isExpandable==true}">
    <img class="hand" (click)="toggleExpandableRow()"  src="./assets/SVGIcons/{{params?.data?.isExpandable==true?'uparrow':'downarrow'}}.svg" width="14" height="14" >
</div>
